import React, { useEffect, useState } from "react";
import io from "socket.io-client";
import { useLocation } from "react-router-dom";
import MoreNews from "../MoreNews/MoreNews";
import "./NewNewsFront.css";
import MiddleCard1 from "./NewNewsCard/MiddleCard/MiddleCard1";
import MiddleCard2 from "./NewNewsCard/MiddleCard/MiddleCard2";
import MiddleCard3 from "./NewNewsCard/MiddleCard/MiddleCard3";
import LeftCard from "./NewNewsCard/LeftCart/LeftCard";
import RightCard from "./NewNewsCard/RightCard/RightCard";
import MiddleCard0 from "./NewNewsCard/MiddleCard/MiddleCard0";

const socket = io.connect("https://mayapurapp.ap-1.evennode.com");

const NewNewsFront = () => {
  const [news, setNews] = useState([]);
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    socket.emit("retrieveHeadlineNews"); //on connection, request 16 news headlines
    socket.on("16NewsHeadlinesRetrieved", (dataObject) => {
      setNews(dataObject);
    });
    return () => {
      socket.off("16NewsHeadlinesRetrieved");
    };
  }, []);


  const middle1 = news.slice(0, 1);
  const middle2 = news.slice(1, 3);
  const middle3 = news.slice(3, 4);
  const middle4 = news.slice(4, 12);
  const firstTenNews = news.slice(12, 21);
  const right = news.slice(21, 31);

  return (
    <div>
      <div>
        <div className="main_content mx-2">
          <div className="d1 px-2">
            <div>
              {firstTenNews.map((newsItem, index) => (
                <LeftCard
                  key={newsItem.id}
                  newsItem={newsItem}
                  cart={`cart${index}`}
                />
              ))}
            </div>
          </div>

          {/* middle section */}
          <div className="d2 p-0 ">
            {/* fast */}
            <div className=" px-2 middle_section">
              {middle1?.map((newsItem, index) => (
                <MiddleCard0
                  key={newsItem.id}
                  newsItem={newsItem}
                  cart={`cart${index}`}
                />
              ))}
            </div>

            {/* 2nd */}
            <div className=" mx-2 pb-2 middle_section border-b-[1px] border-[#ccc]">
              {middle2.map((newsItem, index) => (
                <MiddleCard2
                  key={newsItem.id}
                  newsItem={newsItem}
                  cart={`cart${index}`}
                />
              ))}
            </div>
            {/* 3rd */}
            <div className=" px-2 middle_section">
              {middle3.map((newsItem, index) => (
                <MiddleCard1
                  key={newsItem.id}
                  newsItem={newsItem}
                  cart={`cart${index}`}
                />
              ))}
            </div>
            {/* 4rd */}
            <div className=" px-2 middle_section">
              {middle4.map((newsItem, index) => (
                <MiddleCard3
                  key={newsItem.id}
                  newsItem={newsItem}
                  cart={`cart${index}`}
                />
              ))}
            </div>
          </div>

          <div className="d3 px-2">
            <div className=" px-2  md Right_section">
              {right.map((newsItem, index) => (
                <RightCard
                  key={newsItem.id}
                  newsItem={newsItem}
                  cart={`cart${index}`}
                />
              ))}
            </div>
          </div>
        </div>

        <MoreNews />
      </div>
    </div>
  );
};

export default NewNewsFront;
